import { useCallback, useRef } from 'react';
import { getLang } from '@/i18n/locale';
import { OneTrustCategories } from '@/tracking/onetrust/constants';
import { useAnalytics } from '@/tracking/analytics';
import { useOneTrustIframe } from '@/util/useAddOneTrustIframe';

// OneTrust injects the actual iframe lazily after consent, so we force
// 100% sizing on both the host div and any descendant div/iframe.
const iframeContainerClass = [
  'h-full w-full border-0',
  '[&_div]:h-full [&_div]:w-full [&_div]:border-0',
  '[&_iframe]:h-full [&_iframe]:w-full [&_iframe]:border-0',
].join(' ');

const MapContainer = ({
  place,
  lat,
  lng,
}: {
  place: string,
  lat: string,
  lng: string,
}) => {
  const a = useAnalytics();
  const div = useRef<HTMLDivElement>(null);

  const onClick = useCallback(() => {
    a.expandImage({ content: 'Google Map' });
  }, [a]);

  useOneTrustIframe(div?.current,
    `https://www.google.com/maps/embed/v1/view?zoom=13&key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY}&language=${getLang()}&center=${lat},${lng}`,
    place || '',
    OneTrustCategories.TargetingCookies,
    {
      loading: 'lazy',
      allowfullscreen: 'allowfullscreen',
    });

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/interactive-supports-focus
    <div role="button" ref={div} onClick={onClick} className={iframeContainerClass} />
  );
};
export default MapContainer;
